import forOwn from 'mout/object/forOwn'
import tallyNodeArray from './tallyNodeArray';
import getAllChildrenNodes from './getAllChildrenNodes';
import nodeHasChildrenQ from './nodeHasChildrenQ';
const uuid = require('uuid/v1')

/**
 * Creates the raw data needed to create skill bars for the subtest report.
 * @param {object} scores from userAssessment.scoring 
 * @param {object} subtest from userAssessment.assessmentSubtests
 * @param {object} nodes from db.collection('knowledgeMapNodes')
 * @param {object} maxNodeLevel from userAssessment.assessmentSet.maxNodeLevels
 * @returns {object} An array of data for skill bars for each level 1 node.
 */
export default function newSubtestReport(scores, subtest, nodes, maxNodeLevel) {
  let newReport = {}
  const subtestId = subtest && subtest.setId

  const byNodeScores = scores.byNode[subtestId]
  const bySubtestScores = scores.bySubtest[subtestId]
  const byItemScores = scores.byItem[subtestId]

  function addSkillBarData(thisLevel, node, allNodes, byNodeScoring, maxLevel, motherNodeId) {
    const allChildrenNodes = getAllChildrenNodes(node, allNodes)
    const tally = tallyNodeArray(allChildrenNodes, byNodeScoring)
    if (tally.possible) {
      newReport[motherNodeId].push({
        id: node.id,
        name: node.name,
        description: node.description.shortDescription,
        raw: tally.raw,
        possible: tally.possible,
        percent: tally.raw / tally.possible,
        level: thisLevel,
      })
      if (nodeHasChildrenQ(node) && thisLevel < maxLevel) {
        // turn into forEach with sorted node.children by name
        function sortNodeChildren(nodeChildren) {
          let children = []
          forOwn(nodeChildren, (val, key) => {
            if (val) {
              children.push(key)
            }
          })
          return children.sort((a, b) => {
            if (nodes[a].name > nodes[b].name) {
              return 1
            } else if (nodes[a].name < nodes[b].name) {
              return -1
            } else {
              return 0
            }
          })
        }
        const sortedNodeChildren = sortNodeChildren(node.children)
        sortedNodeChildren.forEach((childKey) => {
          addSkillBarData(thisLevel + 1, allNodes[childKey], allNodes, byNodeScoring, maxLevel, motherNodeId)
        })
        //forOwn(node.children, (val, key) => {
        //  if (val) {
        //    addSkillBarData(thisLevel + 1, allNodes[key], allNodes, byNodeScoring, maxLevel, motherNodeId)
        //  }
        //})
      }
    }
  }

  const motherNode = subtest && nodes[subtest.nodeTag]
  let parentNodes = []
  forOwn(motherNode.children, (val, key, o) => {
    if (val) {
      parentNodes.push(key)
    }
  })

  parentNodes.forEach((parentNodeId) => {
    newReport[parentNodeId] = []
    addSkillBarData(1, nodes[parentNodeId], nodes, byNodeScores, maxNodeLevel, parentNodeId)
  })

  return {
    id: uuid(),
    report: newReport,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/newSubtestReport.js